<template>
<el-row :gutter="15" style="height: 100%;padding: 0 10px;" class="business-form">
    <el-col :sm="24" class="add_infoDiv">
        <div class="add_info_title">查看信息
            <span class="info_btn">
                <i class="el-icon-minus"></i>
                <i class="el-icon-close" @click.stop="close"></i>
            </span>
        </div>
        <div class="add_info_tab">
             <el-tabs v-model="ativeName" @tab-click="handleClick">
                <el-tab-pane label="老基本信息" name="1">
                    <div class="basic_content">
                        <div class="basic_info">
                            <div class="basic_info_div">
                                <div class="avatar-uploader"> <img  width="100%" height="100%"  :src="dialogImageUrl" alt=""></div>
                            </div>
                            <div class="basic_info_div1">
                                <el-form ref="form" :model="form" :inline="true" label-width="90px">
                                    <div class="form-div">
                                        <el-form-item label="姓名">
                                            <el-input v-model="form.name" ></el-input>
                                        </el-form-item>
                                        <el-form-item label="性别">
                                            <el-select v-model="form.sex">
                                                <el-option label="男" value="1">男</el-option>
                                                <el-option label="女" value="2">女</el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="身份证号">
                                            <el-input v-model="form.idNumber"></el-input>
                                        </el-form-item>
                                    </div>
                                    <div class="form-div">
                                        <el-form-item label="出生年月">
                                            <el-input v-model="form.birthday"></el-input>
                                        </el-form-item>
                                       <el-form-item label="年龄">
                                            <el-input v-model="form.age"></el-input>
                                        </el-form-item>
                                        <el-form-item label="手机号码">
                                            <el-input v-model="form.phone"></el-input>
                                        </el-form-item>
                                    </div>
                                    <div class="form-div">
                                        <el-form-item label="民族">
                                            <el-input v-model="form.nation"></el-input>
                                        </el-form-item>
                                        <el-form-item label="婚姻状态">
                                            <el-select v-model="form.marriageStatus">
                                                <el-option label="未婚" value="1">未婚</el-option>
                                                <el-option label="已婚" value="2">已婚</el-option>
                                                <el-option label="离婚" value="3">离婚</el-option>
                                                <el-option label="丧偶" value="4">丧偶</el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="生活区域">
                                            <el-select v-model="form.lifeAreas">
                                                <el-option label="城市" value="1">城市</el-option>
                                                <el-option label="农村" value="2">农村</el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                    <div class="form-div">
                                        <el-form-item label="家庭号码">
                                            <el-input v-model="form.familyPhone"></el-input>
                                        </el-form-item>
                                        <el-form-item label="用户类型">
                                            <el-select v-model="form.type">
                                                <el-option label="普通客户" value="1">普通客户</el-option>
                                                <el-option label="老干服务对象" value="4">老干服务对象</el-option>
                                                <el-option label="政府援助客户" value="6">政府援助客户</el-option>
                                                <el-option label="D类援助客户" value="8">D类援助客户</el-option>
                                                 <el-option label="残联服务对象" value="3">残联服务对象</el-option>
                                                 <el-option label="文明办服务对象" value="10">文明办服务对象</el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                </el-form>
                            </div>
                        </div>
                        <div class="basic_info_1">
                            <el-form ref="form" :model="form" :inline="true" label-width="90px">
                                <div class="form-div">
                                    <el-form-item label="居住情况">
                                        <el-radio-group v-model="form.juzhuCommunity" style="margin:10px">
                                            <el-radio label="4" >独自居住</el-radio>
                                            <el-radio label="5">与配偶居住</el-radio>
                                            <el-radio label="3">与子女居住</el-radio>
                                            <el-radio label="6">其他</el-radio>
                                        </el-radio-group>
                                       <el-input v-model="form.otherJuzhuCommunity"></el-input>
                                    </el-form-item>
                                    <el-form-item label="经济来源">
                                        <el-checkbox-group v-model="checkList2">
                                            <el-checkbox label="0">养老金</el-checkbox>
                                            <el-checkbox label="1">子女供养</el-checkbox>
                                            <el-checkbox label="2">救济优抚</el-checkbox>
                                            <el-checkbox label="3">兼职</el-checkbox>
                                            <el-checkbox label="4">其他</el-checkbox>
                                        </el-checkbox-group>
                                        <el-input v-model="form.otherEconomicSource"></el-input>
                                    </el-form-item>
                                </div>
                                <div class="form-div">
                                    <el-form-item label="证号">
                                        <el-input v-model="form.certificateNumber"></el-input>
                                        <el-checkbox-group v-model="checkList3">
                                            <el-checkbox label="0">低保证金</el-checkbox>
                                            <el-checkbox label="1">优抚证</el-checkbox>
                                            <el-checkbox label="2">失独证</el-checkbox>
                                            <el-checkbox label="3">其他</el-checkbox>
                                        </el-checkbox-group>
                                        <el-input v-model="form.otherCertificateType"></el-input>
                                    </el-form-item>
                                    <el-form-item label="离退休前职务职称" class="form-label">
                                        <el-input v-model="form.postTitle"></el-input>
                                    </el-form-item>
                                </div>
                                <div class="form-div">
                                    <el-form-item label="个人喜好" class="form-like">
                                        <el-checkbox-group v-model="checkList4">
                                            <el-checkbox label="0">棋牌</el-checkbox>
                                            <el-checkbox label="1">舞蹈</el-checkbox>
                                            <el-checkbox label="2">诗词</el-checkbox>
                                            <el-checkbox label="3">戏曲</el-checkbox>
                                            <el-checkbox label="4">钓鱼</el-checkbox>
                                            <el-checkbox label="5">书画</el-checkbox>
                                            <el-checkbox label="6">收藏</el-checkbox>
                                            <el-checkbox label="7">摄影</el-checkbox>
                                            <el-checkbox label="8">旅游</el-checkbox>
                                            <el-checkbox label="9">唱歌</el-checkbox>
                                            <el-checkbox label="10">其他</el-checkbox>
                                        </el-checkbox-group>
                                        <el-input v-model="form.otherPersonalHobby"></el-input>
                                    </el-form-item>
                                </div>
                                <div class="form-div">
                                      <el-form-item label="市" class="form-input">
                                       <el-select class="fl form-input" v-model="form.city"  placeholder="请选择市" >
                                       </el-select>
                                    </el-form-item>
                                    <el-form-item label="区" class="form-input">
                                        <el-select class="fl form-input" v-model="form.zone" placeholder="请选择区" >
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="街道" class="form-input">
                                         <el-select class="fl form-input"  v-model="form.street"  placeholder="请选择街道" >
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="社区" class="form-input">
                                       <el-select class="fl form-input"  v-model="form.shequ"  placeholder="请选择社区" >
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div class="form-div form-flex">
                                    <el-form-item label="详细地址">
                                        <el-input v-model="form.address"></el-input>
                                    </el-form-item>
                                    <el-form-item label="居住地址">
                                        <el-input v-model="form.currentAddress"></el-input>
                                    </el-form-item>
                                </div>
                                <div class="form-div form-flex">
                                    <el-form-item label="附加信息">
                                        <el-input v-model="form.moreinfo" :rows="2" type="textarea"></el-input>
                                    </el-form-item>
                                </div>
                                <div class="form-div">
                                    <el-form-item label="照片上传">
                                        <div style="display:none;">
                                            <input @change="fileChange2" id="dictUpload2" type="file" />
                                        </div>
                                        <label for="dictUpload2" class="up__speech">
                                            <span class="up__speech-txt">选择文件</span>
                                        </label>
                                    </el-form-item>
                                </div>
                            </el-form>
                        </div>
                        <div class="basic_info_2">
                            <div class="basic_title">居家养老信息</div>
                            <el-form ref="form2" :model="form2" :inline="true">
                                <div class="form-div">
                                    <el-form-item label="老人类别">
                                        <el-checkbox-group v-model="checkList5">
                                            <el-checkbox label="0">特困老人</el-checkbox>
                                            <el-checkbox label="1">低保老人</el-checkbox>
                                            <el-checkbox label="2">建档立卡贫困老人</el-checkbox>
                                            <el-checkbox label="3">优抚对象</el-checkbox>
                                            <el-checkbox label="4">失独老人</el-checkbox>
                                            <el-checkbox label="5">残疾老人</el-checkbox>
                                            <el-checkbox label="9">计划生育特殊家庭成员</el-checkbox>
                                            <el-checkbox label="空巢老人">空巢老人</el-checkbox>
                                            <el-checkbox label="农村留守老人">农村留守老人</el-checkbox>
                                            <el-checkbox label="6">其他</el-checkbox>
                                        </el-checkbox-group>
                                        <el-input v-model="form.otherMinzhengIndex"></el-input>
                                    </el-form-item>
                                    <el-form-item label="政府购买对象">
                                        <el-checkbox-group v-model="checkList6">
                                             <el-checkbox label="0">70岁以上享受城乡低保待遇</el-checkbox>
                                            <el-checkbox label="1">80岁以上重点优抚对象</el-checkbox>
                                            <el-checkbox label="2">80岁以上失独老人</el-checkbox>
                                        </el-checkbox-group>
                                    </el-form-item>
                                    <el-form-item label="是否为政府购买对象">
                                        <el-radio-group v-model="form2.government">
                                            <el-radio label="0">是</el-radio>
                                            <el-radio label="1">否</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item label="期望养老模式">
                                        <el-checkbox-group v-model="checkList8">
                                            <el-checkbox label="0">居家养老</el-checkbox>
                                            <el-checkbox label="1">社区养老</el-checkbox>
                                            <el-checkbox label="2">机构养老</el-checkbox>
                                            <el-checkbox label="3">其他</el-checkbox>
                                        </el-checkbox-group>
                                        <el-input v-model="form2.otherPattern"></el-input>
                                    </el-form-item>
                                </div>
                                <div class="form-div">
                                    <el-form-item label="期望的服务">
                                        <el-checkbox-group v-model="checkList9">
                                            <el-checkbox label="0">家政服务</el-checkbox>
                                            <el-checkbox label="1">生活照料</el-checkbox>
                                            <el-checkbox label="2">健康咨询</el-checkbox>
                                            <el-checkbox label="3">精神慰藉</el-checkbox>
                                            <el-checkbox label="4">陪同就医</el-checkbox>
                                            <el-checkbox label="5">换季服务</el-checkbox>
                                            <el-checkbox label="6">助浴服务</el-checkbox>
                                            <el-checkbox label="7">助残服务</el-checkbox>
                                            <el-checkbox label="8">助洁服务</el-checkbox>
                                            <el-checkbox label="9">助餐服务</el-checkbox>
                                            <el-checkbox label="10">助行服务</el-checkbox>
                                            <el-checkbox label="11">定制服务</el-checkbox>
                                        </el-checkbox-group>
                                    </el-form-item>
                                </div>
                            </el-form>
                        </div>
                        <div class="basic_info_3">
                            <div class="basic_info_left">
                                <div class="basic_title">监护人或紧急联系人信息</div>
                                <div class="basic_item">
                                    <div class="item_left">
                                        <div class="avatar-uploader"><i class="avatar-uploader-icon"></i></div>
                                        <div style="display:none;">
                                            <input @change="fileChange1" id="dictUpload1" type="file" />
                                        </div>
                                        <label for="dictUpload1" class="up__speech">
                                            <span class="up__speech-txt">选择文件</span>
                                        </label>
                                    </div>
                                    <div class="item_right">
                                        <div class="item_list clearfix">
                                            <label>志愿者</label>
                                            <el-input v-model="volunteer1Name"></el-input>
                                        </div>
                                        <div class="item_list clearfix">
                                            <label>志愿者电话</label>
                                            <el-input v-model="VolunteerPhone1"></el-input>
                                        </div>
                                    </div>
                                </div>
                                <div class="basic_item">
                                    <div class="item_left">
                                        <div class="avatar-uploader"><i class="avatar-uploader-icon"></i></div>
                                        <div style="display:none;">
                                            <input @change="fileChange1" id="dictUpload1" type="file" />
                                        </div>
                                        <label for="dictUpload1" class="up__speech">
                                            <span class="up__speech-txt">选择文件</span>
                                        </label>
                                    </div>
                                    <div class="item_right">
                                        <div class="item_list clearfix">
                                            <label>志愿者</label>
                                            <el-input v-model="volunteer2Name"></el-input>
                                        </div>
                                        <div class="item_list clearfix">
                                            <label>志愿者电话</label>
                                            <el-input v-model="VolunteerPhone2"></el-input>
                                        </div>
                                    </div>
                                </div>
                                <div class="basic_item">
                                    <div class="item_left">
                                        <div class="avatar-uploader"><i class="avatar-uploader-icon"></i></div>
                                        <div style="display:none;">
                                            <input @change="fileChange1" id="dictUpload1" type="file" />
                                        </div>
                                        <label for="dictUpload1" class="up__speech">
                                            <span class="up__speech-txt">选择文件</span>
                                        </label>
                                    </div>
                                    <div class="item_right">
                                        <div class="item_list clearfix">
                                            <label>志愿者</label>
                                            <el-input v-model="volunteer3Name"></el-input>
                                        </div>
                                        <div class="item_list clearfix">
                                            <label>志愿者电话</label>
                                            <el-input v-model="VolunteerPhone3"></el-input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="basic_info_right">
                                <div class="basic_title">配偶紧急联系人</div>
                                <div class="basic_item">
                                    <div class="item_left">
                                        <div class="avatar-uploader"><i class="avatar-uploader-icon"></i></div>
                                        <div style="display:none;">
                                            <input @change="fileChange1" id="dictUpload1" type="file" />
                                        </div>
                                        <label for="dictUpload1" class="up__speech">
                                            <span class="up__speech-txt">选择文件</span>
                                        </label>
                                    </div>
                                    <div class="item_right">
                                        <div class="item_list clearfix">
                                            <label>姓名</label>
                                            <el-input v-model="form2.jtcyname3"></el-input>
                                        </div>
                                        <div class="item_list clearfix">
                                            <label>关系</label>
                                            <el-input v-model="form2.jtcyrelation3"></el-input>
                                        </div>
                                        <div class="item_list clearfix">
                                            <label>性别</label>
                                            <el-select v-model="form2.jtcysex3">
                                                <el-option label="男" value="1"></el-option>
                                                <el-option label="女" value="2"></el-option>
                                            </el-select>
                                        </div>
                                        <div class="item_list clearfix">
                                            <label>年龄</label>
                                            <el-input v-model="form2.jtcyage3"></el-input>
                                        </div>
                                        <div class="item_list clearfix">
                                            <label>民族</label>
                                            <el-input v-model="form2.jtcynation3"></el-input>
                                        </div>
                                    </div>
                                </div>
                                <div class="item_list clearfix">
                                    <label>身份证号</label>
                                    <el-input v-model="form2.jtcyidNumber3"></el-input>
                                </div>
                                <div class="item_list clearfix">
                                    <label>户口所在地</label>
                                    <el-input v-model="form2.jtcylocation3"></el-input>
                                </div>
                                <div class="item_list clearfix">
                                    <label>联系电话</label>
                                    <el-input v-model="form2.jtcyphone3"></el-input>
                                </div>
                                <div class="item_list clearfix">
                                    <label>联系地址</label>
                                    <el-input v-model="form2.jtcyaddress3"></el-input>
                                </div>
                            </div>
                        </div>
                        <div class="basic_info_3">
                            <div class="basic_info_left">
                                <div class="basic_title direct">直系亲属紧急联系人</div>
                                <div class="basic_item">
                                    <div class="item_left">
                                        <div class="avatar-uploader"><i class="avatar-uploader-icon"></i></div>
                                        <div style="display:none;">
                                            <input @change="fileChange1" id="dictUpload1" type="file" />
                                        </div>
                                        <label for="dictUpload1" class="up__speech">
                                            <span class="up__speech-txt">选择文件</span>
                                        </label>
                                    </div>
                                    <div class="item_right">
                                        <div class="item_list clearfix">
                                            <label>姓名</label>
                                            <el-input v-model="form2.jtcyname2"></el-input>
                                        </div>
                                        <div class="item_list clearfix">
                                            <label>关系</label>
                                            <el-input v-model="form2.jtcyrelation2"></el-input>
                                        </div>
                                        <div class="item_list clearfix">
                                            <label>性别</label>
                                            <el-select v-model="form2.jtcysex2">
                                                <el-option label="男" value="1">男</el-option>
                                                <el-option label="女" value="2">女</el-option>
                                            </el-select>
                                        </div>
                                        <div class="item_list clearfix">
                                            <label>联系电话</label>
                                            <el-input v-model="form2.jtcyphone2"></el-input>
                                        </div>
                                        <div class="item_list clearfix">
                                            <label>备用电话</label>
                                            <el-input v-model="form2.jtcybyphone2"></el-input>
                                        </div>
                                    </div>
                                </div>
                                <div class="item_list clearfix">
                                    <label>联系地址</label>
                                    <el-input v-model="form2.jtcyaddress2"></el-input>
                                </div>
                            </div>
                            <div class="basic_info_right">
                                <div class="basic_title urgent">紧急联系人</div>
                                <div class="basic_item">
                                    <div class="item_left">
                                        <div class="avatar-uploader"><i class="avatar-uploader-icon"></i></div>
                                        <div style="display:none;">
                                            <input @change="fileChange1" id="dictUpload1" type="file" />
                                        </div>
                                        <label for="dictUpload1" class="up__speech">
                                            <span class="up__speech-txt">选择文件</span>
                                        </label>
                                    </div>
                                    <div class="item_right">
                                        <div class="item_list clearfix">
                                            <label>姓名</label>
                                            <el-input v-model="form2.jtcyname1"></el-input>
                                        </div>
                                        <div class="item_list clearfix">
                                            <label>关系</label>
                                            <el-input v-model="form2.jtcyrelation1"></el-input>
                                        </div>
                                        <div class="item_list clearfix">
                                            <label>性别</label>
                                            <el-select v-model="form2.jtcysex1">
                                                <el-option label="男" value="1">男</el-option>
                                                <el-option label="女" value="2">女</el-option>
                                            </el-select>
                                        </div>
                                        <div class="item_list clearfix">
                                            <label>联系电话</label>
                                            <el-input v-model="form2.jtcyphone1"></el-input>
                                        </div>
                                        <div class="item_list clearfix">
                                            <label>备用电话</label>
                                            <el-input v-model="form2.jtcybyphone1"></el-input>
                                        </div>
                                    </div>
                                </div>
                                <div class="item_list clearfix">
                                    <label>联系地址</label>
                                    <el-input v-model="form2.jtcyaddress1"></el-input>
                                </div>

                            </div>
                        </div>
                        <div class="basic_info_4">
                            <div class="basic_title">操作历史记录</div>
                            <div class="basic_info4_left">
                                <div class="item_left">
                                    <div class="item_list clearfix">
                                        <label>登记时间</label>
                                        <el-input v-model="form.entrytime"></el-input>
                                    </div>
                                    <div class="item_list clearfix">
                                        <label>签约时间</label>
                                        <el-input v-model="form.qianYueTime"></el-input>
                                    </div>
                                    <div class="item_list clearfix">
                                        <label>注销时间</label>
                                        <el-input v-model="form.zhuXiaoTime"></el-input>
                                    </div>
                                    <div class="item_list clearfix">
                                        <label>信息取消时间</label>
                                        <el-input v-model="form.isDeadDate"></el-input>
                                    </div>
                                      <div class="item_list clearfix">
                                        <label>社区审核时间</label>
                                        <el-input v-model="form.sqTime"></el-input>
                                    </div>
                                     <div class="item_list clearfix">
                                        <label>街道审核时间</label>
                                        <el-input v-model="form.jdTime"></el-input>
                                    </div>
                                     <div class="item_list clearfix">
                                        <label>区政府审核时间</label>
                                        <el-input v-model="form.qzTime"></el-input>
                                    </div>
                                </div>
                                <div class="item_left">
                                    <div class="item_list clearfix">
                                        <label>登记人</label>
                                        <el-input v-model="form.addPerson"></el-input>
                                    </div>
                                    <div class="item_list clearfix">
                                        <label>签约人</label>
                                        <el-input v-model="form.qianYuePerson"></el-input>
                                    </div>
                                    <div class="item_list clearfix">
                                        <label>注销人</label>
                                        <el-input v-model="form.zhuXiaoPerson"></el-input>
                                    </div>
                                    <div class="item_list clearfix">
                                        <label>实体取消时间</label>
                                        <el-input v-model="form.isFreeDate"></el-input>
                                    </div>
                                      <div class="item_list clearfix">
                                        <label>社区审核人</label>
                                        <el-input v-model="form.sqPreson"></el-input>
                                    </div>
                                     <div class="item_list clearfix">
                                        <label>街道审核人</label>
                                        <el-input v-model="form.jdPreson"></el-input>
                                    </div>
                                     <div class="item_list clearfix">
                                        <label>区政府审核人</label>
                                        <el-input v-model="form.qzPreson"></el-input>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </el-tab-pane>

                  <el-tab-pane label="健康信息" name="2">
                    <div class="fl health-right">
                        <el-form ref="form" :model="form3" :inline="true" label-width="90px">

                            <div class="form-div basic_info_1 basic_info_health basic_info_history">
                                <el-form-item label="病史">
                                    <el-checkbox-group v-model="checkList11">
                                         <el-checkbox label="0">健康</el-checkbox>
                                        <el-checkbox label="1">高血压</el-checkbox>
                                        <el-checkbox label="2">糖尿病</el-checkbox>
                                        <el-checkbox label="3">冠心病</el-checkbox>
                                        <el-checkbox label="4">恶性肿瘤</el-checkbox>
                                        <el-checkbox label="5">结核病</el-checkbox>
                                        <el-checkbox label="6">肝炎</el-checkbox>
                                        <el-checkbox label="7">脑卒中</el-checkbox>
                                        <el-checkbox label="8">精神疾病</el-checkbox>
                                        <el-checkbox label="9">慢性阻塞性肺疾病</el-checkbox>
                                        <el-checkbox label="11">慢性支气管炎</el-checkbox>
                                        <el-checkbox label="12">帕金森综合症 </el-checkbox>
                                        <el-checkbox label="13">腰椎间盘突出</el-checkbox>
                                        <el-checkbox label="14">阿尔茨海默病</el-checkbox>
                                        <el-checkbox label="15">心脏病</el-checkbox>
                                        <el-checkbox label="16">肺气肿</el-checkbox>
                                        <el-checkbox label="17">白内障</el-checkbox>
                                        <el-checkbox label="18">脑血栓</el-checkbox>
                                        <el-checkbox label="19">风湿病</el-checkbox>
                                        <el-checkbox label="20">脑中风</el-checkbox>
                                        <el-checkbox label="21">高脂血症 </el-checkbox>
                                        <el-checkbox label="22">哮喘</el-checkbox>
                                        <el-checkbox label="23">意外伤害</el-checkbox>

                                        <div>
                                            <el-checkbox label="其他"></el-checkbox>
                                            <el-input class='vm' style='width: auto;margin: -10px 0 0 10px;' v-model="form.diseaseOther"></el-input>
                                        </div>
                                    </el-checkbox-group>

                                </el-form-item>
                            </div>
                        </el-form>
                    </div>
                    <p class="clearfix"></p>
                    <el-form ref="form" :model="form" :inline="true" label-width="130px">
                        <div class="form-div">
                            <el-form-item label="老人自理类别">
                                <el-checkbox-group v-model="checkList12">
                                    <el-checkbox label="0">自理</el-checkbox>
                                    <el-checkbox label="1">失能</el-checkbox>
                                    <el-checkbox label="2">半失能</el-checkbox>
                                    <el-checkbox label="3">失智</el-checkbox>
                                    <el-checkbox label="6">轻度依赖</el-checkbox>
                                    <el-checkbox label="7">重度依赖</el-checkbox>
                                    <el-checkbox label="8">不能自理</el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                        </div>
                        <el-row>
                        <el-col :span="12">
                            <div class="form-div">
                                <el-form-item label="经常服用药物">
                                    <el-input v-model="form.yaowu" :rows="2" type="text"></el-input>
                                </el-form-item>
                            </div>
                            <div class="form-div">
                                <el-form-item label="备注">
                                    <el-input v-model="form.oldremark" :rows="2" type="text"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="form-div">
                                <el-form-item label="听力状况">
                                    <el-checkbox-group v-model="checkList14">
                                         <el-checkbox label="1">良好</el-checkbox>
                                        <el-checkbox label="2">一般</el-checkbox>
                                        <el-checkbox label="3">很大声才能听见</el-checkbox>
                                        <el-checkbox label="4">听不见</el-checkbox>
                                    </el-checkbox-group>
                                </el-form-item>
                            </div>

                            <div class="form-div">
                                <el-form-item label="药物过敏情况">
                                    <el-input v-model="form.guoming" :rows="2" type="text"></el-input>
                                </el-form-item>
                            </div>

                            <div class="form-div">
                                <el-form-item label="绑定设备(IMEI)">
                                    <el-input v-model="form.IMEI" :rows="2" type="text"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        </el-row>
                    </el-form>
                    <h3 class="basic_title">健康记录</h3>
                    <el-table class="sms-table"
                        :data="tableDatasss"
                          ref="multipleTable"
                            stripe
                            tooltip-effect="dark"
                            @selection-change="handleSelectionChange"
                            style="width: 100%">
                        <el-table-column
                            prop="sugarEmpty"
                            label="心率"
                            show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                            prop="pressureLow"
                            show-overflow-tooltip
                            label="血压低压">
                        </el-table-column>
                        <el-table-column
                            prop="pressureHigh"
                            show-overflow-tooltip
                            label="血压高压">
                        </el-table-column>
                        <el-table-column
                            prop="sugarPlasma"
                            show-overflow-tooltip
                            label="血糖">
                        </el-table-column>
                        <el-table-column
                            prop="timeStart"
                            show-overflow-tooltip
                            label="上传时间">
                        </el-table-column>
                        <el-table-column
                            prop="fromApp" :formatter = "fromAppFormat"
                            show-overflow-tooltip
                            label="数据来源">
                        </el-table-column>
                    </el-table>
                    <!-- 分页开始  -->
                    <Paginationmini :pageConfig="pageConfig6" @currentPage="currentChange6" @pageSize="pageSizeChange6"></Paginationmini>

                    <h3 class="basic_title">体检记录</h3>
                    <el-table class="sms-table"
                        :data="tableDataExam"
                          ref="multipleTable"
                            stripe
                            tooltip-effect="dark"
                            @selection-change="handleSelectionChange"
                            style="width: 100%">
                        <el-table-column
                            prop="recordNo"
                            label="测量编号"
                            show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                            prop="measureTime"
                            show-overflow-tooltip
                            label="测量时间">
                        </el-table-column>
                        <el-table-column
                            prop="height"
                            show-overflow-tooltip
                            label="身高(cm)">
                        </el-table-column>
                        <el-table-column
                            prop="weight"
                            show-overflow-tooltip
                            label="体重(kg)">
                        </el-table-column>
                        <el-table-column
                            prop="opt"
                            show-overflow-tooltip
                            label="查看 ">
                            <template slot-scope="scope">
                            <i class="el-icon-search" @click.stop="queryInfo(scope.row.id)" title="查看"> </i>
                        </template>
                            <router-link tag="a" target="_blank" to="/about">新品</router-link>
                        </el-table-column>
                    </el-table>
                    <!-- 分页开始  -->
                    <Paginationmini :pageConfig="pageConfigx" @currentPage="currentChangex" @pageSize="pageSizeChangex"></Paginationmini>
                </el-tab-pane>
                <el-tab-pane label="政府援助信息" name="3">
                     <div class="basic_title">享受的服务信息</div>
                	<el-form ref="form" class="form-service" :model="form6" :inline="true" label-width="180px">
                        <div class="clearfix">
                            <div class='fl form-tab'>
                                <div class="form-div">
                                     <el-form-item  label="服务类型" prop="isDead">
                                        <el-checkbox-group v-model="isDead">
                                            <el-checkbox label="1">信息服务</el-checkbox>
                                        </el-checkbox-group>
                                    </el-form-item>
                                    <el-form-item prop="isFree">
                                        <el-checkbox-group v-model="isFree">
                                        <el-checkbox label="1">实体服务</el-checkbox>
                                        </el-checkbox-group>
                                    </el-form-item>
                                </div>
                                <div class="form-div">
                                    <el-form-item label="用户手机套餐">
                                        <el-select placeholder="请选择" v-model="form.mobileMenuid">
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div class="form-div">
                                    <el-form-item label="用户享受的服务类别">
                                        <el-select placeholder="请选择" v-model="form.customerTypeid">
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class='fl form-tab'>
                                <div class="form-div">
                                    <el-form-item label="服务状态">
                                        <el-select placeholder="请选择" v-model="form.states">
                                            <el-option label="待签约" value="1"></el-option>
                                            <el-option label="在用" value="2"></el-option>
                                            <el-option label="注销" value="4"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div class="form-div">
                                    <el-form-item label="用户手机型号">
                                        <el-select placeholder="请选择" v-model="form.phoneModelid">
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div class="form-div">
                                    <el-form-item label="政府援助次数">
                                        <el-input v-model="form.freeCount"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>

                        <div class="form-div form-textarea">
                            <el-form-item label="状态变更原因">
                                <el-input placeholder="请输入" type="textarea" v-model="form.statesChgRsn"></el-input>
                            </el-form-item>
                        </div>
                        <div class="form-div form-textarea">
                            <el-form-item label="审核拒绝原因">
                                <el-input type="textarea" v-model="form.statesjujue"></el-input>
                            </el-form-item>
                        </div>
					    <p><br /></p>
                	</el-form>
                </el-tab-pane>
                  <el-tab-pane label="历史回复" name="4">
                    <el-table class="sms-table"
                        :data="tableData"
                        stripe
                        tooltip-effect="dark"
                        @selection-change="handleSelectionChange"
                        style="width: 100%">
                        <el-table-column
                            prop="name"
                            label="时间"
                            show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                            prop="idcard"
                            show-overflow-tooltip
                            label="回复类型">
                        </el-table-column>
                        <el-table-column
                            prop="code"
                            show-overflow-tooltip
                            label="回访需求">
                        </el-table-column>
                        <el-table-column
                            prop="company"
                            show-overflow-tooltip
                            label="通话记录">
                        </el-table-column>
                        <el-table-column
                            prop="company"
                            show-overflow-tooltip
                            label="回访流程">
                        </el-table-column>
                        <el-table-column
                            prop="company"
                            show-overflow-tooltip
                            label="数据来源">
                        </el-table-column>
                    </el-table>
                    <!-- 分页开始  -->
                    <Paginationmini :pageConfig="pageConfig3" @currentPage="currentChange7" @pageSize="pageSizeChange7"></Paginationmini>
                </el-tab-pane>
               <el-tab-pane label="客户电子账户" name="5"></el-tab-pane>
                <el-tab-pane label="兴康管家信息" name="6"></el-tab-pane>
                <el-tab-pane label="客户地理位置" name="7">
                       <el-button @click.stop="queryCustomerAddress">查询服务对象位置</el-button>
                       <el-button @click.stop="queryServePerson">查询周围服务人员</el-button>
                      <div id="container" class="mymap" style="width:100%;height:900px"></div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </el-col>
</el-row>
</template>


<script>
import {metaDataMgrDao} from '@/api/dao.js'
import Paginationmini from  '../add/pagination-mini'
import {mapState, mapActions} from 'vuex'
import AMap from 'AMap';
export default {
    props:['id'],
    data() {
        return {
            belongAddressId:'',
            belongAddressLevel:'',
            belongProvinceId:'',
            tableDatasss:[],
            tableDataExam:[],
            tableData:[],
            counter: this.id,
            imageUrl: '',
            dialogImageUrl:'',
            activeName : '1',
            checkList1:[''],
            checkList2:[''],
            checkList3:[''],
            checkList4:[''],
            checkList5:[''],
            checkList6:[''],
            checkList7:[''],
            checkList8:[''],
            checkList9:[''],
            checkList11:[''],
            checkList12:[''],
            checkList13:[''],
            checkList14:[''],
            shi:'',
            qu:'',
            jd:'',
            sq:'',
            volunteer1Name:'',
            VolunteerPhone1:'',
            volunteer2Name:'',
            VolunteerPhone2:'',
            volunteer3Name:'',
            VolunteerPhone3:'',
            address:'',
            loading: false,
            form: {
                    city:'',
                    zone:'',
                    street:'',
                    shequ:'',
                    name:'',
                    sex:'',
                    idNumber:'',
                    brithday:'',
                    age:'',
                    address:'',
                    birthday:'',
                    community:'',
                    familyphone:'',
                    moreinfo:'',
                    phone:'',
                    states:'0',
                    type:'',
                    communityid:'',
                    addperson:'',
                    entrytime:'',
                    qianyueperson:'',
                    qianyuetime:'',
                    zhuxiaoperson:'',
                    zhuxiaotime:'',
                    currentAddress:'',
                    lifeAreas:'',
                    marriageStatus:'',
                    specialCommunity:'',
                    //volunteerida:'',
                    //volunteeridb:'',
                   // volunteeridc:'',
                    //statesjujue:'',
                    age:'',
                    isDeaddate:'',
                    isFreedate:'',
                    //addpersonid:'',
                    //pics:'',
                    //applyimg:'',
                    //hkbimgb:'',
                   // idcardimgf:'',
                    //idcardimgz:'',
                    //allergicType:'',
                    //allergy:'',
                    //bloodType:'',
                    certificateNumber:'',
                    economicSource:'',
                    minzhengIndex:'',
                    certificateType:'',
                    //otherAllergicType:'',
                    otherCertificateType:'',
                    otherEconomicSource:'',
                    otherMinzhengIndex:'',
                    otherPersonalHobby:'',
                    personalHobby:'',
                    postTitle:'',
                    //sysEndCood:''
                    diseaseOther:'',
                    oldremark:'',
                    yaowu: '',
                    guoming: '',
                    imei: '',
                    isDead: '',
                    isFree: '',
                    mobileMenuid: '',
                    freeCount: '',
                    statesChgRsn: '',
                    statesjujue: '',
                     // sqTime:'',
                    // jdTime:'',
                    // qzTime:'',
                    // sqPreson:'',
                    // jdPreson:'',
                    // qzPreson:'',
            },
              form2:{
                    jtcyaddress1:'',
                    jtcyaddress2:'',
                    jtcyname1:'',
                    jtcyname2:'',
                    jtcyphone1:'',
                    jtcyphone2:'',
                    jtcyrelation1:'',
                    jtcyrelation2:'',
                    ischegnshisanwu:'',
                    //isnongcunwubao:'',
                    //desiredService:'',
                    government:'',
                    governmentTarget:'',
                    jtcyaddress3:'',
                    jtcyage3:'',
                    jtcybyphone1:'',
                    jtcybyphone2:'',
                    jtcyidNumber3:'',
                    jtcylocation3:'',
                    jtcyname3:'',
                    jtcynation3:'',
                    jtcyphone3:'',
                    jtcyrelation3:'',
                    jtcysex1:'',
                    jtcysex2:'',
                    jtcysex3:'',
                    otherPattern:'',
                    pattern:'',


            },
            form3:{},
            form6:{},
               isDead: [''],
               isFree: [''],
               latitude:'',
               longitude:'',
              //健康信息
            form5: {
                xinlv1: '',
                xinlv2: '',
                di1: '',
                di2: '',
                gao1: '',
                gao2: '',
                tang1: '',
                tang2: '',
            },
             form9:{
                name:'',
                phone:'',
                address:'',
            },
             pageConfig3: {
                pageSize: 6,
                total: 0,
                pageNo: 1
            },
             pageConfig6: {
                pageSize: 5,
                total: 0,
                pageNo: 1
            },
            pageConfigx: {
                pageSize: 5,
                total: 0,
                pageNo: 1
            },

        };
    },

    methods: {
        fromAppFormat(row, column) {

            if(row.fromApp === 1){
				return "兴康服务通";
			}else {
				return "其他来源";
			}
        },
        //勾选数据
        handleSelectionChange:function (val) {

        },
      metaDataMgrDaos(){
        this.loading=true;
        var formData = new FormData();
        formData.append("id",this.counter)
        metaDataMgrDao.findCustomersId(formData).then(resp=>{

          if(resp.code=="200"){
            let obj =  resp.content
            if(obj.idNumber!=null){
                var age=(new Date().getFullYear()) - (obj.idNumber.substring(6, 10));
                obj.age=age;
                var brithday=(obj.idNumber.substring(6, 10))+"-"+(obj.idNumber.substring(10, 12))+"-"+(obj.idNumber.substring(12, 14));
                obj.birthday=brithday;
            }
                obj.type=obj.type.toString();
                obj.states=obj.states.toString();
                if(obj.economicSource!=null){
                this.checkList2=obj.economicSource.split(",");
                };
                if(obj.certificateType!=null){
                  this.checkList3=obj.certificateType.split(",");
                };
                 if(obj.disease!=null){
                  this.checkList11=obj.disease.split(",");
                };
                 if(obj.specialCommunity!=null){
                  this.checkList12=obj.specialCommunity.split(",");
                };
                if(obj.juzhuCommunity!=null){
                  this.checkList13=obj.juzhuCommunity.split(",");
                };
                 if(obj.tingCommunity!=null){
                  this.checkList14=obj.tingCommunity.split(",");
                };
                if(obj.personalHobby!=null){
                    this.checkList4=obj.personalHobby.split(",");
                };
                if(obj.minzhengIndex !=null){
                    this.checkList5=obj.minzhengIndex.split(",");
                };
                if(obj.volunteeridaName !=null){
                    this.volunteer1Name=obj.volunteeridaName;
                };
                if(obj.volunteeridaPhone !=null){
                    this.VolunteerPhone1=obj.volunteeridaPhone;
                };
                if(obj.volunteeridbName !=null){
                    this.volunteer2Name=obj.volunteeridbName;
                };
                if(obj.volunteeridbPhone !=null){
                    this.VolunteerPhone2=obj.volunteeridbPhone;
                };
                if(obj.volunteeridcName !=null){
                    this.volunteer3Name=obj.volunteeridcName;
                };
                if(obj.volunteeridcPhone !=null){
                    this.VolunteerPhone3=obj.volunteeridcPhone;
                };
                 if(obj.photo !=null){

                    this.dialogImageUrl=obj.photo;
                    console.log(this.dialogImageUrl)
                };
                if(obj.isDead !=null){

                 this.isDead=obj.isDead.split(",");
                   console.log(this.isDead);
                };
                 if(obj.isFree !=null){
                    this.isFree=obj.isFree.split(",");
                };
                if(obj.ec !=null){

                    if(obj.ec.governmentTarget !=null){
                        this.checkList6=obj.ec.governmentTarget.split(",");
                    };
                    if(obj.ec.pattern !=null){
                        this.checkList8=obj.ec.pattern.split(",");
                    };
                    if(obj.ec.desiredService !=null){
                        this.checkList9=obj.ec.desiredService.split(",");
                    };
                    this.form2=obj.ec;
                };
                this.form=obj;
                 this.loading=false;
          }else{

		  }
           this.loading=false
          console.log(resp);
        })
      },
      queryInfo(id){
        sessionStorage.setItem("laorenid",id);
        let routeData = this.$router.resolve({
            path: "/screen5"
        });
        window.open(routeData.href, '_blank');
      },


     saveBtn(formName){
       this.$refs[formName].validate((valid) => {
            if (valid) {
          var params=JSON.stringify(this.form);
             console.log(params);
          var params2=JSON.stringify(this.form2);
			metaDataMgrDao.updateCustomers(params,params2).then(resp =>{
                        if(resp.code=="200"){
                            this.$alert("提交成功", '提交结果', {
                                confirmButtonText: '确定',
                                type: 'success',
                                callback: action => {
                                     this.$emit('closeQueryInfo',true)
                                },
                            });
                        }
                        else{
                            this.$alert("提交失败", '提交结果', {
                                confirmButtonText: '确定',
                                type: 'warning',
                                callback: action => {
                                },
                            });
                        }
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },

        currentChange7(currentPage) {
            this.pageConfig3.pageNo =  currentPage

        },
        pageSizeChange7(size) {
            this.pageConfig3.pageSize = size
        },
        //tab切换
        handleClick(){

        },
        fileChange1(){

        },
        fileChange2(){

        },
        close(){
            this.$emit('closeAddService',true)
        },
       //健康记录查询
        CustomerHealthy(){
            this.tableLoading = true;
            var formData = new FormData();
            formData.append("customerId",this.counter)
            formData.append("pageNo",this.pageConfig6.pageNo)
            formData.append("pageSize",this.pageConfig6.pageSize)
            metaDataMgrDao.findCustomerHealthy(formData).then(resp=>{
            if(resp.code=="200"){
                if(resp.content!=null){
                        console.log(resp);
                        this.tableDatasss=[];
                        let list =  resp.content.list;
                        let currentPageNo = resp.content.pageNo;
                        let currentFirstIndex = (currentPageNo-1)*this.pageConfig6.pageSize+1;
                        for(let o of list) {
                        o.index = currentFirstIndex;
                        o.key = currentFirstIndex;
                        currentFirstIndex++;
                    }
                        this.pageConfig6.total= resp.content.count;
                        this.tableDatasss = this.tableDatasss.concat(list)

                }else{
                        console.log(resp);
                        this.tableDatasss=[];
                        var count =0;
                        this.pageConfig6.total= count;
                }

            }else{
                this.tableDatasss = this.tableDatasss.concat(null)
            }
                this.tableLoading = false;
                console.log(resp);
            })
       },
        currentChange6 : function (currentPage) {
                this.pageConfig6.pageNo = currentPage
                this.CustomerHealthy()
        },
        pageSizeChange6(size) {
                this.pageConfig6.pageSize = size
        },

        //体检记录查询
        CustomerPhysicalExam(){
            this.tableLoading = true;
            var formData = new FormData();
            formData.append("IdCode",this.form.idNumber)
            formData.append("pageNo",this.pageConfigx.pageNo)
            formData.append("pageSize",this.pageConfigx.pageSize)
            metaDataMgrDao.findMedicalExaminationReport(formData).then(resp=>{
                if(resp.code=="200"){
                    if(resp.content!=null){
                            console.log(resp);
                            this.tableDataExam=[];
                            let list =  resp.content.list;
                            let currentPageNo = resp.content.pageNo;
                            let currentFirstIndex = (currentPageNo-1)*this.pageConfigx.pageSize+1;
                            for(let o of list) {
                            o.index = currentFirstIndex;
                            o.key = currentFirstIndex;
                            currentFirstIndex++;
                        }
                            this.pageConfigx.total= resp.content.count;
                            this.tableDataExam = this.tableDataExam.concat(list)

                    }else{
                            console.log(resp);
                            this.tableDataExam=[];
                            var count =0;
                            this.pageConfigx.total= count;
                    }

                }else{
                    this.tableDataExam = this.tableDataExam.concat(null)
                }
                this.tableLoading = false;
                console.log(resp);
            })
       },
        currentChangex : function (currentPage) {
                this.pageConfigx.pageNo = currentPage
                this.CustomerPhysicalExam()
        },
        pageSizeChangex(size) {
                this.pageConfigx.pageSize = size
        },

       //地图加载
       loadmap(point){
        const map = new AMap.Map('container', {
          zoom: 9
        });

      },
      queryCustomerAddress(){
            var _this = this;
            var d = new Date();
            var formData = new FormData();
            formData.append("phone",this.form.phone);
            formData.append("type",this.form.type);
            if(this.belongAddressLevel=='1'){
                    formData.append("belongProvinceId",this.belongProvinceId)
             }else{
                    formData.append("belongAddressId",this.belongAddressId)
             }
            metaDataMgrDao.getSHBLocationByPhone(formData).then(resp=>{
            if(resp.code=="200"){
                let  obj=  resp.content
                console.log(obj);
                this.latitude=obj.addressLat;
                this.longitude=obj.addressLng;
                this.form9.name=obj.name;
                this.form9.phone=obj.phone;
                this.form9.address=obj.address;
                console.log(this.latitude);
                 let point=[this.longitude,this.latitude]
                console.log(point);
                const map = new AMap.Map('container', {
                zoom: 15,
                center: point
                });
                // 创建地址解析器实例
                var geocoder = new AMap.Geocoder({
                    radius: 1000,
                    extensions: "all"
                });
                 var address;
                //根据经纬度，获取地址
                geocoder.getAddress(point, function(status, result){

                   address=result.regeocode.formattedAddress;
                   _this.address=address;

                });
                console.log(this.address)
                const  marker = new AMap.Marker({
                    icon: "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
                    position: point,
                    offset:new AMap.Pixel(16, -45)
                });
                marker.setMap(map);
               //鼠标点击marker弹出自定义的信息窗体
                AMap.event.addListener(marker, 'click', function () {
                    //实例化信息窗体
                   let date=d.getFullYear().toString()+'-'+(d.getMonth()+1).toString()+'-'+d.getDate().toString()+' '+d.getHours().toString()+':'+d.getMinutes().toString()+':'+d.getSeconds().toString();
				   let title='用户:【'+_this.form9.name+'】的定位信息';
					let content = [];
                   	content.push('电话：'+_this.form9.phone);
					content.push('地址：'+_this.address);
					content.push('经度：'+_this.longitude);
					content.push('纬度：'+_this.latitude);
					content.push('定位时间：'+date);
                    const infoWindow = new AMap.InfoWindow({
                        isCustom: true,  //使用自定义窗体
                        content: _this.createInfoWindow(title, content.join("<br/>")),
                      offset:new AMap.Pixel(16, -45)
                    });
                    infoWindow.open(map, marker.getPosition());
                });
            }else if(resp.code=="300"){
                this.$message(resp.message);
            }else if(resp.code=="400"){
               this.$alert("认证失败，重新登录！", '系统提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning',
                      callback: action => {
                            this.$router.push({ path: '/login' });
                      },
              });
            }else{
               this.$message("系统异常，请稍后重试");
            }
        });
      },

  //构建自定义信息窗体
   createInfoWindow(title, content) {
        var _this = this;
        var info = document.createElement("div");
        info.className = "info";

        //可以通过下面的方式修改自定义窗体的宽高
        info.style.width = "400px";


        // 定义顶部标题
        var top = document.createElement("div");
        var titleD = document.createElement("div");
        var closeX = document.createElement("img");
        top.className = "info-top";
        titleD.innerHTML = title;
        closeX.src = "http://webapi.amap.com/images/close2.gif";
        closeX.onclick = _this.closeInfoWindow;

        top.appendChild(titleD);
        top.appendChild(closeX);
        info.appendChild(top);


        // 定义中部内容
        var middle = document.createElement("div");
        middle.className = "info-middle";
        middle.style.backgroundColor = 'white';
        middle.innerHTML = content;
        info.appendChild(middle);

        // 定义底部内容
        var bottom = document.createElement("div");
        bottom.className = "info-bottom";
        bottom.style.position = 'relative';
        bottom.style.top = '0px';
        bottom.style.margin = '0 auto';
        var sharp = document.createElement("img");
        sharp.src = "http://webapi.amap.com/images/sharp.png";
        bottom.appendChild(sharp);
        info.appendChild(bottom);
        return info;
    },
        //关闭信息窗体
        closeInfoWindow() {

        // _this.infoWindow.close();
        },
      queryServePerson(){
            var _this = this;
            var formData = new FormData();
            formData.append("addressLat", this.latitude);
            formData.append("addressLng",this.longitude);
            metaDataMgrDao.findServePerson(formData).then(resp=>{
            if(resp.code=="200"){
                let  obj=  resp.content
                console.log(this.latitude);
                 let point=[this.latitude,this.longitude]
                console.log(point);
                const map = new AMap.Map('container', {
                zoom: 9
                });
                const  marker = new AMap.Marker({
                    icon: "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
                    position: point,
                    offset:new AMap.Pixel(16, -45)
                });

                marker.setMap(map);
               //鼠标点击marker弹出自定义的信息窗体
                AMap.event.addListener(marker, 'click', function () {
                    //实例化信息窗体
				   let title='用户:【'+_this.form9.name+'】的定位信息';
					let content = [];
                   	content.push('电话：'+_this.form9.phone);
					content.push('地址：'+_this.form9.address);
					content.push('经度：'+_this.longitude);
					content.push('纬度：'+_this.latitude);
					content.push('定位时间：'+date);
                    const infoWindow = new AMap.InfoWindow({
                        isCustom: true,  //使用自定义窗体
                        content: _this.createInfoWindow(title, content.join("<br/>")),
                        offset: new AMap.Pixel(16, -45)
                    });
                    infoWindow.open(map, marker.getPosition());
                });
            }
        });
        }
    },
 mounted : function(){
         if(sessionStorage.getItem("user")){
          var a=sessionStorage.getItem("user");
           this.belongAddressId=a;
           console.log( this.belongAddressId)
          };
        if(sessionStorage.getItem("belongAddressLevel")){
            var a=sessionStorage.getItem("belongAddressLevel");
            this.belongAddressLevel=a;
            console.log(this.belongAddressLevel)
        };
        if(sessionStorage.getItem("belongProvinceId")){
            var a=sessionStorage.getItem("belongProvinceId");
            this.belongProvinceId=a;
            console.log(this.belongProvinceId)
        };
           setTimeout(() => {
                this.metaDataMgrDaos();
                this.CustomerHealthy();
                this.CustomerPhysicalExam();
                  this.loadmap();
           }, 0);
         },
          components: { Paginationmini }
}
</script>

<style lang="less">
.avatar-uploader{
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 178px;
    height: 178px;
}
.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
.add_info_title{
    height:40px;
    line-height:40px;
    font-size:24px;
    .info_btn{
        float:right;
    }
}
.basic_info{
    display:flex;
}
.up__speech{
    background: #5a9ad0;
    color: #fff;
    border-radius: 3px;
    width: 178px;
    height: 40px;
    line-height: 40px;
    display: inline-block;
    text-align: center;
    margin-top: 10px;
}
.basic_info_div1{
    background: #d7d9db;
    flex: 1;
    margin-left: 10px;
}
.add_infoDiv {
    .form-div .el-form-item{
        width:auto !important;
    }
    .basic_info_1{
        .el-form-item__label{
            font-size: 16px;
        }
        .el-form-item__content{
            display:flex;
            .el-input{
                width:25%;
            }
        }
        .el-checkbox-group{
            margin:0 10px;
        }
        .form-label {
            .el-form-item__label{
                width:140px!important;
            }
            .el-input{
                width:100%;
            }
        }
        .form-like{
            width:100%!important;
            .el-form-item__content{
                width:100%;
            }
        }
        .form-input{
            .el-input{
                width:100%;
            }
        }
        .form-flex{
            .el-form-item{
                flex:1;
                .el-form-item__content,.el-input{
                    width:100%;
                }

            }

        }
    }
}
.basic_info_2{
    border-bottom:1px solid #ccc;
}
.basic_title{
    font-size:20px;
    color:#4f94cd;
    margin: 20px auto;
    position:relative;
    padding-left: 10px
}
.direct{
    color:#ff9000;
}
.urgent{
    color:#ff4343;
}
.basic_title::before{
    content:"";
    width:3px;
    height: 24px;
    background: #4f94cd;
    position: absolute;
    left: 0;
    top: 2px;
}
.basic_title.urgent::before{
    background:#ff4343;
}
.basic_title.direct::before{
    background:#ff9000;
}
.basic_info_3{
    display:flex;
    .basic_info_left,.basic_info_right{
        width:50%;
        flex:1;
    }
    .basic_item{
        display:flex;
    }
    .item_left{
        margin-bottom:10px;
    }
    .avatar-uploader{
        width:140px;
        height:140px;
        background:#d7d9db;
    }
    .up__speech{
        width:140px;
    }
    .item_right{
        margin-left:20px;
        flex:1;
        margin-right:20px;
    }
}
.item_list{
    margin:20px 0;
    label{
        width:90px;
        padding-right:10px;
        text-align:right;
        display:inline-block;
        line-height:30px;
        float:left;
    }
    .el-select{
        width:72%;
        float:left;
        .el-input{
            width:100%;
        }
    }
    .el-input{
        width:72%;
        float:left;
    }
}
.basic_info_4{
    border-top:1px solid #ccc;
}
.basic_info4_left{
    display:flex;
    .item_left{
        width:50%;
    }
}
.saveBtn{
    width:50%;
    margin:0 auto;
    display: inherit;
    margin-bottom: 30px;
}
</style>
